/** @jsx jsx */
import React from 'react';
import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';

import { Button, Link, RightArrow, } from '@argo/ui-elements';

const FooterWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const ReadMoreLink = styled.div`
  display: inline-block;
  flex-direction: column;
  height: auto;
  padding-top: 6px;
  text-align: center;
`;

const PrivacyLink = styled.div`
  display: inline-block;
  flex-direction: column;
  height: auto;
  padding-top: 6px;
  text-align: center;
`;

const FooterContainer = styled.div`
  padding-bottom: 10px;
`;

interface FooterProps {
  readMoreLink: string;
  privacyPolicyLink: string;
  onFooterReadMoreClick: () => void;
  onFooterPrivacyLinkClick: () => void;
}

export default class Footer extends React.PureComponent<FooterProps> {
  public render(): JSX.Element {
    const {
      readMoreLink,
      privacyPolicyLink,
      onFooterReadMoreClick,
      onFooterPrivacyLinkClick,
    } = this.props;

    return (
      <FooterContainer>
        <FooterWrapper>
          <ReadMoreLink id="ReadMoreLink">
            {readMoreLink
              ? (
                <Button
                  href={readMoreLink}
                  target="_blank"
                  buttonType="text"
                  enableCapitalize={false}
                  text="Read more on KBB.com"
                  onClick={(): void => { onFooterReadMoreClick(); }}
                >
                  <RightArrow
                    size="10"
                    color="brightBlue"
                  />
                </Button>
              )
              : ('')}
          </ReadMoreLink>
          <PrivacyLink
            id="PrivacyLink"
            onClick={(): void => { onFooterPrivacyLinkClick(); }}
          >
            <Link
              href={privacyPolicyLink}
              target="_blank"
              type="small"
            >
              Privacy
            </Link>
          </PrivacyLink>
        </FooterWrapper>
      </FooterContainer>
    );
  }
}
